export default "__VITE_PUBLIC_ASSET__ee8dcdc9__"